// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"1869":"bb2369c20631ccd1f0bf","9588":"a1e4bc7a7e0356206671"}[chunkId] + ".css";
};